module.exports = __webpack_public_path__ + "2c68cf640144c30bcd15d45cc029b025.ttf";